import Swal from 'sweetalert2';
import { UserProfileMraApi } from '../../Apis/user/ApiConfig';
import {
    USER_PROFILE_MRA_ERROR,
    USER_PROFILE_MRA_SUCCESS,
    USER_PROFILE_MRA_REQUEST,
} from '../../Types/user/Types';
import { UserProfileActionHandler } from './SettingsUserProfile';

export const UserProfileMraSuccess = (res) => {
    return {
        type: USER_PROFILE_MRA_SUCCESS,
        payload: res,
    };
};
export const UserProfileMraError = (error) => {
    return {
        type: USER_PROFILE_MRA_ERROR,
        error: error,
    };
};

export const UserProfileMraRequest = (res) => {
    return {
        type: USER_PROFILE_MRA_REQUEST,
        payload: res,
    };
};

export const SettingsUserProfileMraActionHandler = (data) => {
    return (dispatch) => {
        dispatch(UserProfileMraRequest());
        try {
            UserProfileMraApi(data)
                .then((res) => {
                    const errorMessage = res?.data?.message;
                    if (res) {
                        if (res && res.data && res.status === 200) {
                            dispatch(UserProfileActionHandler());
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'Authentication successful!',
                                showConfirmButton: false,
                                timer: 1500,
                            });
                            dispatch(UserProfileMraSuccess(res.data));
                        } else {
                            Swal.fire({
                                icon: 'error',
                                title: 'Oops...',
                                text: 'Something went wrong!',
                                confirmButtonColor: 'rgb(231,52,70)',
                            });
                            dispatch(UserProfileMraError(errorMessage));
                        }
                    } else {
                        dispatch(UserProfileMraError(errorMessage));
                    }
                })
                .catch((err) => {
                    dispatch(UserProfileMraError('Something Went Wrong!!!'));
                });
        } catch (err) {
            dispatch(UserProfileMraError(err));
        }
    };
};
